import { Component } from '@angular/core';
import { OrderDetailsService } from '@spartacus/order/components';
import { Order } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { fadeIn, fadeOut } from '../../../../../../../custom/animation/custom-animations';
import { ICON_TYPE } from '../../../../../../../custom/icons/icon.model';
import { CustomUserOrderService } from "../../../../../core/user/facade/order/custom-user-order.service";

@Component({
  selector: 'app-custom-order-details',
  templateUrl: './custom-order-details.component.html',
  styleUrls: ['./custom-order-details.component.scss'],
  animations: [fadeIn, fadeOut],
  standalone: false
})
export class CustomOrderDetailsComponent {

  iconType = ICON_TYPE;
  orderDetails: Observable<Order> = this.orderDetailsService.getOrderDetails();

  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected userOrderService: CustomUserOrderService,
  ) {}

  repeatOrder(orderCode: string): void {
    this.userOrderService.repeatOrder(orderCode);
  }
}
